var _excluded = ["entity", "customClasses", "includeFieldSet"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import { Field } from 'formik';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import GenericFormElement from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/GenericFormElement';
var WebformEmailConfirm = function WebformEmailConfirm(props) {
  var entity = props.entity,
    customClasses = props.customClasses,
    includeFieldSet = props.includeFieldSet,
    fieldProps = _objectWithoutProperties(props, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    emailConfirmValue = _useState2[0],
    setEmailConfirmValue = _useState2[1];
  var title = entity.get('#title');
  var confirmTitle = entity.get('#confirm__title');
  var required = entity.get('#required');
  var description = entity.get('#description');
  var placeholder = entity.get('#placeholder');
  var requiredError = entity.get('#required_error') || t(['webform.components.email_confirm.required', 'webform.required', 'webform_required']);
  var key = entity.get('#webform_key');
  var errorId = "".concat(key, "--error");
  var descriptionId = "".concat(key, "--description");
  var wrapperClassNames = c('TextField', 'WebformEmail', 'WebformEmail--Confirm', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  var elementClassNames = c(entity.getIn(['#attributes', 'class', 0], ''), {
    error: fieldProps.errors[title] && fieldProps.touched[title] ? 'error' : ''
  });
  function validation(value) {
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var error;
    if (required && !value || required && value === '') {
      error = requiredError;
    }
    if (value && (!emailConfirmValue || emailConfirmValue === '')) {
      error = requiredError;
    }
    if (value && emailConfirmValue && value !== emailConfirmValue) {
      error = t(['webform.components.email_confirm.values_not_equal', 'webform.invalid', 'webform_invalid']);
    }
    if (!regex.test(String(value).toLowerCase())) {
      error = requiredError || t(['webform.components.email_confirm.invalid', 'webform.email_invalid', 'webform_email_invalid']);
    }
    return error;
  }
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: wrapperClassNames,
    title: title,
    required: required,
    description: description,
    fieldName: key,
    touched: props.touched[key],
    error: props.errors[key],
    errorId: errorId,
    descriptionId: descriptionId,
    includeFieldSet: includeFieldSet
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
    className: elementClassNames,
    name: key,
    type: "email",
    value: props.values[key],
    placeholder: placeholder,
    validate: validation
  })), /*#__PURE__*/React.createElement("div", null, confirmTitle && /*#__PURE__*/React.createElement("label", {
    htmlFor: "".concat(key, "-confirm")
  }, confirmTitle, !required && '(optioneel)'), /*#__PURE__*/React.createElement(Field, {
    className: elementClassNames,
    name: "".concat(key, "-confirm"),
    type: "email",
    value: emailConfirmValue,
    placeholder: placeholder,
    onChange: function onChange(e) {
      setEmailConfirmValue(e.target.value);
    }
  })));
};
export default WebformEmailConfirm;